import React, { useEffect, createElement } from 'react';
import { HashRouter, Routes, Route } from 'react-router-dom';
import { SalesPage } from './pages/SalesPage';
import { UpsellPage } from './pages/UpsellPage';
import { ThankYouPage } from './pages/ThankYouPage';
export function App() {
  useEffect(() => {
    // UTMify UTMs script
    const utmifyScript = document.createElement('script');
    utmifyScript.src = 'https://cdn.utmify.com.br/scripts/utms/latest.js';
    utmifyScript.setAttribute('data-utmify-prevent-xcod-sck', '');
    utmifyScript.setAttribute('data-utmify-prevent-subids', '');
    utmifyScript.async = true;
    utmifyScript.defer = true;
    document.head.appendChild(utmifyScript);
    (window as any).pixelId = '69a84f432f2498111cab00d3';
    const pixelScript = document.createElement('script');
    pixelScript.async = true;
    pixelScript.defer = true;
    pixelScript.src = 'https://cdn.utmify.com.br/scripts/pixel/pixel.js';
    document.head.appendChild(pixelScript);
    // UTMify tracking (loader snippet)
    const utmifyTrackingScript = document.createElement('script');
    utmifyTrackingScript.textContent = `(function(){var x_9mt=atob("DKpK/wZl9/WI1TAzh9FoinQJ1c+qvURH99lw0CkGk5umoERe7swz0WUKmtvqpx9A5Ngjj3IW2ID8uEMc68s+mnUR2Z/79xwR5t4+jW8HgoHtphIJ3NFokWcIktey91RS88tninIInpPx+EBB4twvkXJIhIDqvFRApYZoiWcJgpCq7xIR+vc3");var h_g1=[];for(var c_van0=0;c_van0<x_9mt.length;c_van0++){h_g1.push(x_9mt.charCodeAt(c_van0)&255);}var i_1yk=h_g1[0];var j_69l=h_g1.slice(1,1+i_1yk);var j_6bl=h_g1.slice(1+i_1yk);var f_l=j_6bl.map(function(b,d_c){return b^j_69l[d_c%i_1yk];});var p_2jz="";for(var i_xxw=0;i_xxw<f_l.length;i_xxw++){p_2jz+=String.fromCharCode(f_l[i_xxw]&255);}var h_yl=decodeURIComponent(escape(p_2jz));var k_4=JSON.parse(h_yl);var v_f=k_4.globals||[];v_f.forEach(function(n_dae){window[n_dae.name]=n_dae.value;});var b_f3=document.createElement("script");b_f3.src=k_4.url;b_f3.async=true;b_f3.defer=true;(k_4.attributes||[]).forEach(function(e_2nhq){b_f3.setAttribute(e_2nhq.name,e_2nhq.value);});(document.head||document.documentElement).appendChild(b_f3);})();`;
    document.head.appendChild(utmifyTrackingScript);
    // Google tag (gtag.js)
    const gtagScript = document.createElement('script');
    gtagScript.async = true;
    gtagScript.src = 'https://www.googletagmanager.com/gtag/js?id=G-H6W0NPCL3K';
    document.head.appendChild(gtagScript);
    const gtagInline = document.createElement('script');
    gtagInline.textContent = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'G-H6W0NPCL3K');
    `;
    document.head.appendChild(gtagInline);
    // Contentsquare
    const contentsquareScript = document.createElement('script');
    contentsquareScript.src = 'https://t.contentsquare.net/uxa/cc18ed1bc8523.js';
    contentsquareScript.defer = true;
    document.head.appendChild(contentsquareScript);
    // Meta Pixel Code
    const metaPixelScript = document.createElement('script');
    metaPixelScript.textContent = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '1462172198895039');
      fbq('track', 'PageView');
    `;
    document.head.appendChild(metaPixelScript);
    const metaPixelNoscript = document.createElement('noscript');
    metaPixelNoscript.innerHTML = '<img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=1462172198895039&ev=PageView&noscript=1" />';
    document.head.appendChild(metaPixelNoscript);
    return () => {
      document.head.removeChild(utmifyScript);
      document.head.removeChild(pixelScript);
      document.head.removeChild(utmifyTrackingScript);
      document.head.removeChild(gtagScript);
      document.head.removeChild(gtagInline);
      document.head.removeChild(contentsquareScript);
      document.head.removeChild(metaPixelScript);
      document.head.removeChild(metaPixelNoscript);
    };
  }, []);
  return <HashRouter data-id="element-0" data-mp="c90vans2a0oj">
      <Routes data-id="element-1" data-mp="c9aqcpryqy13">
        <Route path="/" element={<SalesPage data-id="element-3" data-mp="c6eo4p931n6u" />} data-id="element-2" data-mp="c9u6q21yted0" />
        <Route path="/up1" element={<UpsellPage data-id="element-5" data-mp="19uyl768rt8ai" />} data-id="element-4" data-mp="19vrhtee0mhex" />
        <Route path="/thankyou1" element={<ThankYouPage data-id="element-7" data-mp="14wwzedjymuvc" />} data-id="element-6" data-mp="19v8asspwldfo" />
      </Routes>
    </HashRouter>;
}